import type { Action } from '@atlassian/react-sweet-state';
import type { Props, State } from '../types.tsx';

export const refreshAllSnippets =
	(): Action<State, Props> =>
	async (api, { insightsRemote }) => {
		insightsRemote.refreshSnippets?.();
	};
